import { all, call, put, takeLatest } from "redux-saga/effects";
import { POST_GIA_HAN_NOPHAITHU } from "actions/GiaHanNoPhaiThu/actionTypes";
import {
  postGiaHanNoPhaiThuFailure,
  postGiaHanNoPhaiThuSuccess,
} from "actions/GiaHanNoPhaiThu";
import GiaHanNoPhaiThuApi from "service/giaHanNoPhaiThuApi";
import { pushNotification } from "utils/notifications";
import { showModalGiaHanNoPhaiThu } from "actions/GiaHanNoPhaiThu";

function* postGiaHanNoPhaiThu(action) {
  try {
    const response = yield call(GiaHanNoPhaiThuApi.add, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(postGiaHanNoPhaiThuFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(postGiaHanNoPhaiThuSuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
        yield put(showModalGiaHanNoPhaiThu());
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(postGiaHanNoPhaiThuFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(postGiaHanNoPhaiThuFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(POST_GIA_HAN_NOPHAITHU, postGiaHanNoPhaiThu);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
